import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { ICreateAppVersionModalOptions } from "./i-create-app-version-modal.options";
import { ICreateAppVersionModalService } from "./i-create-app-version-modal.service";
import { Inject, Injectable } from "@angular/core";
import { CreateAppVersionModalComponent } from "./create-app-version-modal.component";

@Injectable()
export class CreateAppVersionModalService implements ICreateAppVersionModalService {
  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
  }

    open(createAppVersionModalOptions: ICreateAppVersionModalOptions): void {
      this._modalService.open(CreateAppVersionModalComponent, {
        styleClass: 'bg-white rounded-lg',
        header: "App Version erstellen",
        showHeader: true,
        closable: true,
        width: '900px',
        closeOnEscape: true,
        dismissableMask: true,
        data: createAppVersionModalOptions
      })
    }
}
